<template>
  <div class="">
    <div class="layout-content" style="background: transparent; margin: 0px">
      <!-- <div v-if="list.length"> -->
      <div v-if="list.length">
        <el-table
          ref="multipleTable"
          :data="list"
          tooltip-effect="dark"
          stripe
          style="width: 100%"
          :header-cell-style="{ 'background-color': '#f8f8f9' }"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"> </el-table-column>
          <el-table-column label="中文名称" show-overflow-tooltip>
            <template slot-scope="scope">{{ scope.row.name }}</template>
          </el-table-column>
          <el-table-column prop="shortName" label="简称" show-overflow-tooltip>
          </el-table-column>
          <el-table-column
            prop="displayOrder"
            label="显示顺序"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column label="语言" show-overflow-tooltip>
            <template slot-scope="scope"
              ><span style="margin-right: 5px">{{
                scope.row.languageType
              }}</span
              ><span
                class="lookClass"
                style="cursor: pointer"
                @click="detailNumbers(scope.row)"
                >{{ scope.row.languageType ? "修改" : "设置" }}</span
              ></template
            >
          </el-table-column>
          <el-table-column label="是否启用" show-overflow-tooltip>
            <template slot-scope="scope"
              ><el-switch
                v-model="scope.row.isEnable"
                active-color="#d13119"
                inactive-color="#dcdfe6"
                @change="(status) => setAudit(scope.row, status)"
              >
              </el-switch
            ></template>
          </el-table-column>
        </el-table>

        <div style="margin-top: 20px">
          <el-button
            @click="batch()"
            style="background-color: #d13119; color: #fff"
            >批量设置语言</el-button
          >
        </div>
      </div>
      <div class="u-empty" v-else>暂无数据</div>
    </div>
    <iModal
      title="请选择语言"
      v-model="rejectModel"
      class-name="vertical-center-modal"
      width="600px"
      :mask-closable="false"
    >
      <div>
        <span>请选择：</span>
        <el-radio v-model="radio" label="1">中文</el-radio>
        <el-radio v-model="radio" label="2">英文</el-radio>
      </div>

      <div slot="footer">
        <Button type="primary" @click="handleSubmitReject()">确定</Button>
        <Button @click="rejectModel = false">取消</Button>
      </div>
    </iModal>

    <div class="catalogue-content"></div>
  </div>
</template>
  
<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

export default {
  name: "areaPage",
  data() {
    return {
      list: [],
      radio: "1",
      rejectModel: false,
      id: "",
      selectId: [],
    };
  },
  components: {
    // exhibitionCarYes,
    // exhibitionCarNo
  },
  computed: {
    ...mapGetters({
      exhibition: "loginModule/getExhibition",
      exhibitionInfo: "hostSetModule/getHostExhibition",
      hostExhibition: "hostSetModule/getHostExhibition",
      exhibitionId: "hostSetModule/getHostExhibition",
    }),
  },
  created() {
    document.title = "中国国际医疗器械博览会 - 产品审核";
    // this.initProType()
    console.log(this.exhibitionId.id);
    // this.exhibitionId =  this.$store.state.hostSetModule.hostExhibition.id
    this.init1();
  },
  methods: {
    ...mapActions({
      getExhibitionArea: "hostManage/getExhibitionArea",
      getAllArea: "hostManage/getAllArea",
      areaLanguageSetting: "hostManage/areaLanguageSetting",
      areaIsEnable: "hostManage/areaIsEnable",
    }),
    setTimes() {
      this.timeShow = true;
    },
    switchBrand(name) {
      this.pageIndex = 1;

      this.init1();
    },

    initStatus() {
      this.pageIndex = 1;
      if (this.newsAudit == 0) {
        this.statusProType = ["wait"];
      }
      if (this.newsAudit == 1) {
        this.statusProType = ["pass", "notpass"];
      }
      this.init1();
    },
    async init() {
      let opt = {
        exhibitionId: this.exhibitionId.id,
      };
      let proData = await this.getExhibitionArea(opt);
      let proData1 = await this.getAllArea(opt);
      this.list = proData1;
    },
    async init1() {
      let opt = {
        exhibitionId: this.exhibitionId.id,
      };
      let proData1 = await this.getAllArea(opt);
      this.list = proData1;
    },

    handleSelectionChange(value) {
      console.log(value);

      this.selectId = [];
      value.forEach((e) => {
        this.selectId.push(e.id);
      });
    },
    batch() {
      if (this.selectId.length == 0) {
        this.$message.error("请先选择修改项！");
        return;
      }
      this.rejectModel = true;
    },
    // 修改订单数
    detailNumbers(item) {
      console.log(item);
      this.id = item.id;
      this.selectId = [];
      this.selectId.push(item.id);
      if (!item.languageType) {
        this.radio = "1";
      } else {
        item.languageType == "中文" ? (this.radio = "1") : (this.radio = "2");
      }
      this.rejectModel = true;
    },
    async handleSubmitReject() {
      console.log(this.radio);
      let res = await this.areaLanguageSetting({
        ids: this.selectId,
        type: this.radio == "1" ? "中文" : "英文",
      });
      if (res && res.successed) {
        this.$Message.success("设置成功");
        this.rejectModel = false;
      }
      this.init1();
    },
    async setAudit(item, status) {
      let res = await this.areaIsEnable({
        id: item.id,
        isEnable: status,
      });
      if (res && res.successed) {
        this.$Message.success("设置成功");
        this.rejectModel = false;
      }
      this.init1();
    },
  },
};
</script>
  
<style scoped lang="scss">
.required {
  color: red;
  margin-right: 4px;
}
.header-tabs {
  // display: flex;
  position: relative;
}
.searchPro {
  position: absolute;
  right: 24px;
  top: 0;
}
.catalogue {
  .header-tool {
    min-height: 90px;
  }

  &-content {
    min-width: 1000px;
    margin: 24px;
    padding: 40px;
    min-height: 500px;
    padding-bottom: 190px;
  }
}

.cib {
  min-width: 1000px;
  margin: 30px;
  padding: 40px;
  min-height: 500px;
  background: #fff;
  padding-bottom: 190px;
}

.spanClass {
  margin-left: 4px;
  margin-right: 4px;
}
.ivu-table-wrapper {
  // padding-bottom: 20px!important;
  overflow: visible !important;
}
.deleteClass {
  color: #f78989;
  // cursor:pointer;
}

.lookClass {
  color: #d13119;
  cursor: pointer;
}

.marLeft {
  margin-left: 15px;
}
::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,
.el-checkbox__input.is-indeterminate .el-checkbox__inner {
  background-color: #d13119 !important;
  border-color: #d13119 !important;
}
::v-depp .el-table .has-gutter .el-table__cell {
  background-color: #f8f8f9 !important;
}
</style>
  